// categoryReducer.js — mirror DealCouponz categoryReducer (subset)
import * as categoryTypes from "../types/categoryTypes";

const initialState = {
  categories: [],
  loading: false,
  error: null,
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case categoryTypes.GET_CATEGORIES_REQUEST:
      return { ...state, loading: true, error: null };

    case categoryTypes.GET_CATEGORIES_SUCCESS: {
      const raw = action.payload;
      const categories = Array.isArray(raw)
        ? raw
        : raw?.categories || [];
      return { ...state, loading: false, categories };
    }

    case categoryTypes.GET_CATEGORIES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default categoryReducer;
